
class Fv
{
  // ---------------------------------------------------------------------------------------------------------
	// --	Fv
	// ---------------------------------------------------------------------------------------------------------

  constructor()
  {
    console.log('Fv')

    //DOM参照
    this.view = $('.sc-fv')
    this.copy = $('.sc-fv__copy >p')
    this.mv = $('.sc-fv__mv')

    //コピーの初期化
    this.orgCopyStr = this.copy.text()
    this.copyStr = ''
    this.copy.empty()

    //メインビジュアルの初期化
    this.mv.find('.sc-fv__mv-img').each(function(index){
      const img = $(this)
      gsap.set(img, {alpha:0})
    })
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	COPY関連
	// ---------------------------------------------------------------------------------------------------------

  showMV()
  {
    this.mvIndex = -1
    this.prevImg = null
    this.currentImg = null
    this.showNextMV()
  }

  showNextMV()
  {
    //前の画像を参照
    this.prevImg = this.currentImg

    //インデックス変更
    this.mvIndex ++
    if(this.mvIndex >= 4) this.mvIndex = 0

    //画像参照
    const img = this.mv.find('.sc-fv__mv-img')[this.mvIndex]
    this.currentImg = img

    //並べ順
    if(this.prevImg) $(this.prevImg).css('z-index', '2')
    $(this.currentImg).css('z-index', '3')

    //アニメーション
    gsap.set(img, {alpha:0, scaleX:1.1, scaleY:1.1})
    gsap.to(img, 1.0, {
      alpha:1,
      ease:'none',
      onComplete:()=>{
        if(this.prevImg)
        {
          $(this.prevImg).css('z-index', '1')
          gsap.set(this.prevImg, {alpha:0, scaleX:1.1, scaleY:1.1})
        }
      }
    })
    gsap.to(img, 8, {
      scaleX:1,
      scaleY:1,
      ease:'power1.out'
    })

    //次へ
    gsap.delayedCall(6.5, this.showNextMV.bind(this))
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	COPY関連
	// ---------------------------------------------------------------------------------------------------------

  showCopy()
  {
    //インデックス
    this.copyIndex = -1

    //コピー表示
    this.copyStep()
  }

  copyStep()
  {
    //インデックス追加
    this.copyIndex ++

    if(this.copyIndex < this.orgCopyStr.length)
    {
      //文字追加
      const char = this.orgCopyStr.charAt(this.copyIndex)
      this.copyStr += char
      this.copy.text(this.copyStr)

      //コピー表示
      if(this.copyIndex == 0) $('.sc-fv__copy').addClass('show')

      //次の文字表示
      gsap.delayedCall(0.15, this.copyStep.bind(this))
    }
    else
    {
      $('.sc-fv__contents').addClass('show')
    }
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Fv
